export const formatDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  
  return `${year}年${month}月${day}日`;
};

export const formatDateForDisplay = (date: Date): string => {
  return formatDate(date);
}; 